<template>
  <div class="checkout-loading">
    <div class="checkout-title-loading loading-shimmer"></div>
    <div class="checkout-body-loading loading-shimmer"></div>
    <div class="checkout-body-loading loading-shimmer"></div>
  </div>
</template>
<script>
export default {
  name: 'checkout-loading'
}
</script>
<style lang="scss" scoped>
// Lines 15-33 match the responsiveness of checkout-content &-inner
.checkout-loading {
  max-width: $grid-breakpoint-sm;
}

.checkout-title-loading,
.checkout-body-loading {
  @media screen and (min-width: $grid-breakpoint-sm) {
    width: 448px;
  }
}

.checkout-title-loading {
  margin-bottom: $spacer-3;
  height: 89px;
}
.checkout-body-loading {
  margin-bottom: $spacer-2;
  height: 48px;
}

// Loading animation matches o-accounts skeletons
.loading-shimmer {
  background-image: linear-gradient(90deg, $gray-500 0%, $gray800 50%, $gray-500 100%);
  background-size: 1000px 1000px;
  background-repeat: repeat;
  animation: shimmerAnimation 4s ease infinite;
}

@keyframes shimmerAnimation {
  0% {
    background-position: 0% 100%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 100%;
  }
}
</style>
